/**
 * Generic async state representation for data that may be loading,
 * in an error state, or successfully resolved.
 *
 * Designed to align with the shape returned by GraphQL query hooks
 * (e.g. Apollo's `{ data, loading, error }`) so future integration
 * maps directly without transformation.
 */

export interface AsyncState<T> {
  data: T | null;
  loading: boolean;
  error: Error | null;
}

export function initialAsyncState<T>(): AsyncState<T> {
  return { data: null, loading: false, error: null };
}

export function loadingAsyncState<T>(existing?: T | null): AsyncState<T> {
  return { data: existing ?? null, loading: true, error: null };
}

export function successAsyncState<T>(data: T): AsyncState<T> {
  return { data, loading: false, error: null };
}

export function errorAsyncState<T>(error: Error, existing?: T | null): AsyncState<T> {
  return { data: existing ?? null, loading: false, error };
}
